export default __webpack_public_path__ + "static/media/item-6.aa01ad8f.png";